import Tables from 'src/class/Tables';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      label: i18n.t('production.motive'),
      prop: "name",
      minWidth: 100
    },
  ];

  return { Table };
};

export default configTable;
